'use strict';

require('../shared/base-entry');
require('./views/all-brands');
require('../shared/post-entry');
